export default __webpack_public_path__ + "static/media/graph.2a2e7eb5.png";